import { CheckCircle2, XCircle } from "lucide-react";
import { cn } from "@/lib/utils";

export function EligCard({ title, eligible, reason, color }) {
  return (
    <div className={cn("p-4 rounded-lg border-2", eligible ? `border-${color}-300 bg-${color}-50` : "border-red-500/30 bg-red-500/10")} data-testid={`elig-${title.replace(/\s/g, '-').toLowerCase()}`}>
      <div className="flex items-center gap-2 mb-2">
        {eligible ? <CheckCircle2 className={`w-5 h-5 text-${color}-600`} /> : <XCircle className="w-5 h-5 text-red-500" />}
        <span className="font-semibold text-sm">{title}</span>
      </div>
      <p className={cn("text-xs", eligible ? `text-${color}-700` : "text-red-600")}>{reason}</p>
    </div>
  );
}
